import axios from "../api"
import { getToken } from "../util/util"
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl"

export const getCredits = (callback) =>
  axios
    .post("/credits/getAll", null, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .then(async (res) => {
      callback?.(res.data);
      return res.data;
    })
    .catch((error) => {
      toast.error(<FormattedMessage id="toast.somethingWentWrong" />);
      console.log("Error fetching credits:", { error });
      throw error;
    });
